import { DtArea } from '@ow/ditto-core'

const { config } = DtArea

export { default as Render } from './render'
export { config }
